import { Component } from '@angular/core';

@Component({
  selector: 'xos-create-password',
  templateUrl: './create-password.component.html',
  styleUrls: ['./create-password.component.scss'],
})
export class CreatePasswordComponent {}
